import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Only initialize PostHog if we have the required environment variables
const shouldUsePostHog = process.env.REACT_APP_POSTHOG_KEY && process.env.REACT_APP_POSTHOG_HOST;

root.render(
  <React.StrictMode>
    {shouldUsePostHog ? (
      <PostHogProvider
        apiKey={process.env.REACT_APP_POSTHOG_KEY}
        options={{
          api_host: process.env.REACT_APP_POSTHOG_HOST,
          capture_pageview: true,
          capture_pageleave: true,
          debug: process.env.NODE_ENV === 'development',
        }}
      >
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();